/**
 * Created by zhangyanbo on 2016/12/30.
 */
import Vue from 'vue';
import tpl from './tpl.html';
import commonService from '../../../common/commonService';
import Loading from '../../../component/Loading.vue';
import ParseUrl from '../../../util/parseUrl';
import Pager from '../../../component/Pager.vue';
import NoData from '../../../component/NoData.vue';


export default Vue.extend({
    name: "blockInfo",
    template: tpl,
    components: {
        Loading,
        Pager,
        NoData
    },
    data(){
        return {
            block: {
                hash: '',//区块hash
                amount: '',//交易金额
                size: '',//区块大小
                num: '',//区块高度
                prize: '',//出块奖励
                tradeNum: '',//交易笔数
                signee: '', //产快代理
                fee: '',//手续费
                time: ''//出块时间
            },
            trade: {
                trade_id: '',
                address_from: '',
                address_to: '',
                type: '',
                time: '',
                fee: ''
            },
            condition: {
                pageNo: 1,
                pageSize: 10
            },
            pageNum: 0,
            param_hash: '',
            currentBlockNum: '',
            bigBlockNum: '',
            currentTradeParam: {},
            currentBlockParam: {},
            isBlockHash: true,
            isShowBlock: true,
            isLoading: false,
            isThroughBlockNum: true,
        }
    },
    created() {
        this.getUrlParam();
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    methods: {
        /*
         * 获取地址栏中参数
         *
         * */
        getUrlParam(){
            let tempParam = ParseUrl();
            if (localStorage.blockPageNo) {
                this.condition.pageNo = localStorage.blockPageNo
            }

            if ('blockHash' in tempParam) {
                this.currentBlockParam = {'block_id': tempParam.blockHash};
                this.isBlockHash = true;
                this.isThroughBlockNum = false;
                this.fetchBlockInfo();
            } else if ('blockNum' in tempParam) {
                if (localStorage.blockNum) {
                    this.currentBlockNum = localStorage.blockNum
                } else {
                    this.currentBlockNum = tempParam.blockNum;
                }

                this.isBlockHash = false;
                this.isThroughBlockNum = true;
                this.currentBlockParam = {'block_num': +this.currentBlockNum};
                this.fetchBlockInfo();
            }
        },

        /*
         * 通过区块hash显示页面
         * */
        fetchBlockInfo() {
            let param = this.currentBlockParam;
            commonService.blockInfo(param).done((rep) => {
                console.log(rep);

                let tempResult = rep.result.data[0];

                this.block.hash = tempResult.block_id;
                this.block.num = tempResult.block_num;
                this.block.size = tempResult.block_size;
                this.block.signee = tempResult.signee;
                this.block.amount = tempResult.trans_amount;
                this.block.tradeNum = tempResult.trans_num;
                this.block.prize = tempResult.block_bonus / 100000;
                this.block.fee = tempResult.trans_fee / 100000;
                this.block.time = tempResult.block_time;
                if (this.isThroughBlockNum == false) {
                    this.currentBlockNum = tempResult.block_num;
                }
                this.param_hash = tempResult.block_id
                this.fetchTradeInfo();


            }).fail((rep) => {
                window.error("网络异常，请稍后再试");
            }).always(() => {

            });
        },
        /*
         * 通过区块hash显示查找交易信息
         *
         * */
        fetchTradeInfo() {
            this.isLoading = true;

            // let param = this.currentTradeParam;
            let param = {
                'block_id': this.param_hash,
                'page': +this.condition.pageNo,
                'per_page': this.condition.pageSize
            }
            commonService.tradeInfo(param).done((rep) => {
                this.pageNum = Math.ceil(rep.result.total / this.condition.pageSize);
                let tempTrade = rep.result.data;
                tempTrade.forEach(function (value, index) {
                    let type = value.trx_type;
                    value.trx_type =
                        type == 0 ? '普通转账' :
                            type == 1 ? '代理领工资' :
                                type == 2 ? '账户注册' :
                                    type == 3 ? '注册代理' :
                                        type == 4 ? '升级代理' :
                                            type == 5 ? '更新账户' :
                                                type == 10 ? '合约注册' :
                                                    type == 11 ? '合约充值' :
                                                        type == 12 ? '合约升级' :
                                                            type == 13 ? '合约销毁' :
                                                                type == 14 ? '合约调用' :
                                                                    type == 15 ? '合约出账' : '';
                })
                this.trade = tempTrade;


            }).fail((rep) => {
                window.error("网络异常，请稍后再试");
            }).always(() => {
                this.isLoading = false;
            });
        },

        /*
         * 查找上一个区块
         *
         * */
        showPrevBlock() {
            this.currentBlockNum = +this.currentBlockNum - 1;
            localStorage.blockNum = +this.currentBlockNum;

            if (this.currentBlockNum <= 0) {
                this.currentBlockNum = 1;
                localStorage.blockNum = +this.currentBlockNum;
                window.toast('没有数据');
                return;
            }
            // this.isBlockHash = false;
            this.currentBlockParam = {'block_num': this.currentBlockNum};
            // window.location.hash ='blockInfo?blockNum='+this.currentBlockNum;
            this.fetchBlockInfo();

            // this.getUrlParam();

        },

        /*
         * 查找下一个区块
         *
         * */
        showNextBlock() {

            commonService.blockInfo({'max_num': "1"}).done((rep) => {
                this.bigBlockNum = rep.result.data.max_num;
                if (this.currentBlockNum >= this.bigBlockNum) {
                    this.currentBlockNum = this.bigBlockNum;
                    localStorage.blockNum = +this.currentBlockNum;
                    window.toast('没有数据');
                    return;
                }
                this.currentBlockNum = +this.currentBlockNum + 1;
                localStorage.blockNum = +this.currentBlockNum;
                this.currentBlockParam = {'block_num': this.currentBlockNum};
                // window.location.hash ='blockInfo?blockNum='+this.currentBlockNum;
                this.fetchBlockInfo();
                // this.getUrlParam();


            }).fail((rep) => {

            }).always(() => {

            });


        },
        /**
         * 分页
         * @param pageNo
         */
        changePage(pageNo) {
            localStorage.blockPageNo = +pageNo;
            this.condition.pageNo = pageNo;
            this.fetchTradeInfo();
        }


    }
});



// WEBPACK FOOTER //
// ./src/module/index/blockInfo/main.js